
import { Folder } from "@/models/tasks/folder";
import { FolderUser } from "@/models/tasks/folder-user";
import { TaskService } from "@/services/task-service";
import { TasksState } from "@/utils/tasks-state";
import Vue from "vue";
import AppEditFolder from "./FolderEditModal.vue";
import AppNewFolderModal from "./NewFolderModal.vue";
import AppRepeatedTaskList from "./RepeatedTaskList.vue";
import { ISelectItem } from "winfakt-vue-components";

export default Vue.extend({
	data() {
		return {
			myFolders: [] as Folder[],
			sharedFolders: [] as Folder[],
			newFolderModal: false,
			toEditFolder: null as null | Folder,
			editFolderModal: false,
			repeatedTaskListFolder: null as null | Folder
		};
	},
	props: {
		state: {
			type: Object as () => TasksState,
			required: true
		}
	},
	computed: {
		activeFolder(): any {
			return [...this.myFolders, ...this.sharedFolders].find(f => (f.ID.toString() == this.$route.params.folderId));
		},
		options(): ISelectItem<Function>[] {
			let result:ISelectItem<Function>[] = [
				{text: this.$ct("edit-folder").toString(), value: this.editFolder, icon: "cog"},
				{text: this.$ct("manage-repeated-tasks"), value: this.manageRepeatedTasks, icon: "calendar"}
			];
			if (this.myFolders.length > 1){
				result.push({text: this.$ct("delete-folder").toString(), value: this.deleteFolder, icon: "trash"});
			}
			return result;
		},
		folderId():number{
			return parseInt(this.$route.params.folderId);
		}
	},
	watch: {
		"state.myFolders": {
			immediate: true,
			handler() {
				this.myFolders = this.state.myFolders.map(f => f.Folder as Folder);
			},
		},
		"state.sharedFolders": {
			immediate: true,
			handler() {
				this.sharedFolders = this.state.sharedFolders.map(f => f.Folder as Folder);
			},
		},
		"toEditFolder": {
			handler(newValue:null | Folder) {
				if (newValue == null) return;
				let index = this.myFolders.findIndex(f=>f.ID == newValue.ID);
				this.myFolders[index] = newValue;
			}
		}
	},
	methods: {
		openNewFolderModal() {
			this.newFolderModal = true;
		},
		manageRepeatedTasks(folder:Folder){
			this.repeatedTaskListFolder = folder;
		},
		async deleteFolder(folder:Folder) {
			let confirm = await this.$confirmBuilder(this.$ct("confirm-delete", {name: folder.Name})).setTitle(this.$ct("common.warning")).setClass("warning").show();
			if (confirm) {
				this.state.deleteFolder(folder);
				if (parseInt(this.$route.params.folderId || "0") == folder.ID) {
					this.$router.push("/tasks");
				}
			}
		},
		async editFolder(folder:Folder) {
			this.toEditFolder = (await TaskService.getFolder(folder.ID)).Folder as Folder;
			this.editFolderModal = true;
		},
		async onOwnedOrderDrop() {
			await this.state.setOwnedFoldersOrder(this.myFolders);
		},
		async onSharedOrderDrop() {
			await this.state.setSharedFolderOrder(this.sharedFolders);
		},
		openFolder(folder: Folder) {
			this.$router.push(`/tasks/${folder.ID}`);
		},
		onNewFolder(folderUser: FolderUser) {
			this.$router.push(`/tasks/${folderUser.FolderID}`);
			this.state.myFolders.push(folderUser);
		},
		async onFolderMouseUp(folder:Folder) {
			if (!this.state.draggedTask) return;

			if (this.state.draggedTask.FolderID != folder.ID) {
				await this.state.moveTaskToFolder(folder, this.state.draggedTask);
			}
			this.state.draggedTask = null;
			return;
		}
	},
	mounted() {
		if (!this.$route.params.folderId && this.myFolders && this.$wf.isMdUp) {
			this.$router.push(`/tasks/` + this.myFolders[0].ID);
		}
	},
	components: {
		AppNewFolderModal,
		AppEditFolder,
		AppRepeatedTaskList
	},
	i18nEx: {
		componentPrefix: "components.tasks"
	}
});
